/** Strip non-alphanumerics, uppercase, limit to 8 chars and insert a dash after 4 (XXXX-XXXX) */
export function formatActivationKey(raw: string): string {
  const clean = raw.replace(/[^A-Z0-9]/gi, '').toUpperCase().slice(0, 8)
  return clean.length > 4 ? `${clean.slice(0, 4)}-${clean.slice(4)}` : clean
}

export function isCompleteActivationKey(value: string): boolean {
  return value.replace(/-/g, '').length === 8
}

/** Pull the most useful message out of an axios/redeem error */
export function getRedeemErrorMessage(err: unknown): string {
  return (
    (err as { response?: { data?: { message?: string } }; message?: string })?.response?.data?.message ??
    (err as { message?: string })?.message ??
    'Something went wrong. Please try again.'
  )
}
